const resolveEvent = (data)=>{
    switch(data.type){
        case 'turn_start':
            return {
                type: 'turn_start',
                turnId: data.turnId
            };
        case 'status':
            return {
                type: 'status',
                phase: data.phase,
                label: data.label
            };
        case 'content_part':
            return {
                type: 'content_part',
                part: data.part
            };
        case 'turn_done':
            return {
                type: 'turn_done',
                messageId: data.messageId
            };
        case 'stream_error':
            return {
                type: 'stream_error',
                code: data.code,
                message: data.message
            };
        default:
            // eslint-disable-next-line no-console
            console.warn("unknown analyst SSE event type: ".concat(data.type), {
                data
            });
            return null;
    }
};
export const createAnalystStreamParser = ()=>{
    return (raw)=>{
        if (raw.data === '[DONE]' || !raw.data) return null;
        const data = JSON.parse(raw.data);
        return resolveEvent(data);
    };
};
